module.exports = __webpack_public_path__ + "assets/img/ea53d74748c6a4e9ada34e62a747025e.svg";